/* eslint
  no-var: 0,
  comma-dangle: 0,
  quotes: 0,
  object-shorthand: 0,
  dot-notation: 0,
  vars-on-top: 0,
  eqeqeq: 0,
  yoda: 0,
  no-unused-vars: 0,
  one-var: 0
*/
import assign from 'object-assign';
import qs from 'qs';
import _ from 'underscore';
import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import ROLES from 'constants/UserRoles';
import AdminConstants from 'constants/AdminConstants';
import { showToast } from 'stores/ToastStore';
import axios from 'axios';
import i18next from 'i18next';
import client from './rest/AdminClient';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import { getBearerGrantTypeAuthHeaders } from '../helpers/auth_helpers';
import fileDownload from 'js-file-download';
import {
  trackAccessorialEvent,
  trackInvoiceEvent,
  trackPayoutEvent,
  EVENTS,
} from '../helpers/analytics';

const Actions = AdminConstants.ActionTypes;

const defaultQueryParams = {
  page: 1,
  page_size: 50,
  sort_by: 'date_created',
};

const extraInvoiceQueryParams = {
  populate: [
    {
      path: 'shipper',
      select: 'company_name email',
    },
  ],
};

const defaultInvoiceQueryParams = assign(
  extraInvoiceQueryParams,
  defaultQueryParams,
);

export async function removeLineItem(lineItem, accounting_type, shipment_id) {
  const queryString = qs.stringify({
    shipment_id,
    accounting_type,
  });

  const options = {
    method: 'delete',
    url: `${API_HOST}/admin/v2/accessorials/${lineItem}?${queryString}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getBearerGrantTypeAuthHeaders(),
    },
  };
  return axios(options);
}

export function generateInvoicesByGrouping(orderId, payload) {
  const options = {
    method: 'post',
    url: `${API_HOST}/api/orders/${orderId}/invoices/group`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getBearerGrantTypeAuthHeaders(),
    },
    data: payload,
  };
  return axios(options).then((response) => {
    const successes = response?.data?.results?.successes ?? [];
    successes.forEach((s) =>
      trackInvoiceEvent(
        EVENTS.INVOICE_CREATED,
        { _id: s?.invoiceId },
        {
          order: { _id: orderId },
          charge_types: s?.chargeTypes,
          delivery_method: s?.deliveryMethod,
          shipment_ids: s?.shipmentIds,
        },
      ),
    );
    return response;
  });
}

export function validateInvoiceChargesByGrouping(orderId, payload) {
  const options = {
    method: 'post',
    url: `${API_HOST}/api/orders/${orderId}/invoices/group/validate`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getBearerGrantTypeAuthHeaders(),
    },
    data: payload,
  };
  return axios(options);
}

export function getPayouts(params = {}) {
  const queryParams = assign({}, defaultQueryParams, params);
  const queryString = qs.stringify(queryParams);
  return client({
    method: 'GET',
    path: `/admin/api/v2/payouts?${queryString}`,
  });
}

export async function generateAndEmailPayoutsReport(payload) {
  const response = await client({
    method: 'POST',
    path: '/admin/api/v2/payouts/send-email',
    entity: JSON.stringify(payload),
  });
  if (response.entity?.success) {
    showToast(
      i18next.t(
        'Export Request received, please wait to receive results via email.',
      ),
      i18next.t(
        'Export Request received, please wait to receive results via email.',
      ),
      'success',
    );
  }
}

export function getPayoutsByNumbers(payoutNumbers, page, pageSize) {
  return client({
    method: 'POST',
    path: `/api/documents/payouts-by-numbers`,
    entity: JSON.stringify({ payoutNumbers, page, pageSize }),
  });
}

export function getCarrierPayouts(id, params = {}) {
  const queryParams = assign({}, defaultQueryParams, params);
  const queryString = qs.stringify(queryParams);
  return client({
    method: 'GET',
    path: `/api/v2/carriers/${id}/payouts?${queryString}`,
  });
}

export async function exportCarrierPayouts(id, params = {}) {
  try {
    const queryParams = assign({}, defaultQueryParams, params);
    const queryString = qs.stringify(queryParams);
    const response = await client({
      method: 'GET',
      path: `/api/v2/carriers/${id}/payouts/export?${queryString}`,
    });
    fileDownload(response.entity, 'carrier-payout-report.csv');
  } catch (e) {
    let errorMessage = typeof e === 'string' ? e : e.message;
    showToast('', errorMessage, 'error');
  }
}

export function getCarrierPayout(userId, id) {
  return client({
    method: 'GET',
    path: `/api/1/carriers/${userId}/payouts/${id}`,
  });
}

export function getPayout(id) {
  return client({
    method: 'GET',
    path: `/admin/api/1/payouts/${id}`,
  });
}

const settlePayout = (id) => {
  return client({
    method: 'POST',
    path: `/admin/api/payouts/${id}/settle`,
  });
};

export const settleBulkStripePayout = (payoutIds) => {
  return client({
    method: 'POST',
    path: '/admin/api/payouts/bulk_settle',
    entity: JSON.stringify({ payoutIds }),
  });
};

export const getPayoutsForShipment = (shipmentId) => {
  return client({
    method: 'GET',
    path: `/api/payouts/shipment/${shipmentId}`,
  });
};

const reprocessCarrierPayout = (id) => {
  return client({
    method: 'POST',
    path: `/api/payouts/${id}/refresh`,
  });
};

export const getInvoices = (path, params = {}) => {
  const queryParams = assign({}, defaultInvoiceQueryParams, params);
  const queryString = qs.stringify(queryParams);
  return client({
    method: 'GET',
    path: `${path}?${queryString}`,
  });
};

const getAdminInvoices = (params) => {
  return getInvoices('/admin/api/v2/invoices', params);
};

const getInvoicesByNumber = (params) => {
  return getInvoices('/admin/api/v2/invoice/search', params);
};

const getInvoicesByNumberShipper = (shipperId, params) => {
  return getInvoices(`api/v2/shippers/${shipperId}/invoice/search`, params);
};

const getShipperInvoices = (shipperId, params) => {
  return getInvoices(`/api/v2/shippers/${shipperId}/invoices`, params);
};
const getAdminInvoicesStats = (params) => {
  return getInvoices('/admin/api/v2/invoices/statstics', params);
};
const getShipperInvoicesStats = (shipperId, params) => {
  return getInvoices(
    `/api/v2/shippers/${shipperId}/invoices/statstics`,
    params,
  );
};

export const getInvoicesForShipment = (shipmentId) => {
  return client({
    method: 'GET',
    path: `/api/invoices/shipment/${shipmentId}`,
  });
};

export function approveCarrierCost(shipmentId, chargeId) {
  const entity = JSON.stringify({
    approval: true,
    shipments: [
      {
        _id: shipmentId,
        ledgerType: 'payables',
        adjustments: [chargeId],
      },
    ],
  });
  return client({
    method: 'PUT',
    path: '/admin/api/jobs/adjustments/approve',
    entity,
  });
}

export function getInvoice(id, userType) {
  let path;
  if (userType === ROLES.ADMIN) {
    path = '/admin/api/1/invoices/';
  } else if (userType === ROLES.SHIPPER) {
    path = '/api/1/invoices/';
  }
  return client({
    method: 'GET',
    path: path + id,
  });
}

const setAutopayEnabled = (id, autopay) => {
  var path = `/admin/api/v2/payouts/${id}/autopay`;
  return client({
    method: 'PUT',
    path: path,
    entity: JSON.stringify({ autopay }),
  });
};

const markAsPaid = (resource, id) => {
  var resources = resource + 's';
  var payload = {
    status: 'paid',
  };
  var entity = JSON.stringify(payload);
  var path = '/admin/api/1/' + resources + '/' + id;
  return client({
    method: 'PATCH',
    path: path,
    entity: entity,
  });
};

const markPayoutAsPaid = (id) => {
  return markAsPaid('payout', id);
};

const markInvoiceAsPaid = (id) => {
  return markAsPaid('invoice', id);
};

const approvePayout = (id) => {
  return client({
    method: 'POST',
    path: `/admin/api/v2/payouts/${id}/approve`,
  });
};

const reversePayoutApproval = (id) => {
  return client({
    method: 'POST',
    path: `/admin/api/v2/payouts/${id}/reverse-approval`,
  });
};

const voidPayout = (id) => {
  return client({
    method: 'POST',
    path: `/admin/api/v2/payouts/${id}/void`,
  });
};

const reversePayoutVoid = (id) => {
  return client({
    method: 'POST',
    path: `/admin/api/v2/payouts/${id}/reverse-void`,
  });
};

const emailTransaction = (resource, id, to, isCreditMemo) => {
  var resources = resource + 's';
  var path = '/api/1/' + resources + '/send';
  var payload = {};
  payload['recipients'] = to;
  payload[resource + '_id'] = id;
  payload['is_credit_memo'] = isCreditMemo;
  // var entity = qs.stringify(payload);
  // return formEncoded({method:'POST', path:path, entity:entity})

  var entity = JSON.stringify(payload);
  return client({
    method: 'POST',
    path: path,
    entity: entity,
  });
};
const emailInvoice = (id, to, isCreditMemo) => {
  return emailTransaction('invoice', id, to, isCreditMemo);
};

const emailPayout = (id, to, isCreditMemo) => {
  return emailTransaction('payout', id, to, isCreditMemo);
};

export const setInvoicePaymentMethod = (payment_method, invoiceId) => {
  const payload = {
    payment_method,
  };
  const path = `/api/v2/invoices/${invoiceId}/payment-method`;
  return client({
    method: 'PATCH',
    path: path,
    entity: JSON.stringify(payload),
  });
};

export const setPayoutPaymentMethod = (payment_method, payoutId) => {
  const payload = {
    payment_method,
  };
  const path = `/api/v2/payouts/${payoutId}/payment-method`;
  return client({
    method: 'PATCH',
    path: path,
    entity: JSON.stringify(payload),
  });
};

const recordPayment = (resource, id, paymentInfo) => {
  var resources = resource + 's';
  var path = '/admin/api/v2/' + resources + '/' + id + '/payments';

  var payload = {
    payment: {
      amount: paymentInfo.amount,
      description: {
        type: paymentInfo.paymentMethod,
        source: 'manual',
      },
    },
  };
  if ('check' == paymentInfo.paymentMethod) {
    payload.payment.date = paymentInfo.checkDate;
    payload.payment.description.check_number = paymentInfo.transactionId;
  } else {
    payload.payment.description.transaction_id = paymentInfo.transactionId;
  }

  if (paymentInfo.transactionDate) {
    payload.payment.description.transaction_date = paymentInfo.transactionDate;
  }
  payload.status = 'partially_paid';

  var entity = JSON.stringify(payload);
  return client({
    method: 'POST',
    path: path,
    entity: entity,
  });
};

const recordPaymentForPayout = (id, paymentInfo) => {
  return recordPayment('payout', id, paymentInfo);
};

const recordPaymentForInvoice = (id, paymentInfo) => {
  return recordPayment('invoice', id, paymentInfo);
};

const regenerateOrderInvoice = (invoiceId, data) => {
  return client({
    method: 'POST',
    path: `/admin/api/1/invoices/${invoiceId}/order/regenerate`,
    entity: JSON.stringify(data),
  });
};

const regenerateShorthaulInvoice = (invoiceId) => {
  return client({
    method: 'POST',
    path: `/admin/api/1/invoices/${invoiceId}/shorthaul/regenerate`,
  });
};

const approveAccessorials = (body) => {
  return client({
    method: 'POST',
    path: `/api/accessorials/approve`,
    entity: JSON.stringify(body),
  });
};

const sendEdiInvoice = async (invoiceId) => {
  return client({
    method: 'POST',
    path: `/admin/api/invoices/${invoiceId}/edi/send`,
  });
};

const updatePayoutJobs = async (payout, jobIds, action) => {
  return client({
    method: 'PUT',
    path: `/admin/api/1/payouts/${payout._id}`,
    entity: JSON.stringify({ payout, jobIds, action }),
  });
};

const updateInvoiceJobs = async (invoice, jobIds, action) => {
  return client({
    method: 'PUT',
    path: `/admin/api/1/invoices/${invoice._id}`,
    entity: JSON.stringify({ invoice, jobIds, action }),
  });
};

const updatePayout = async (id, payload) => {
  return client({
    method: 'POST',
    path: `/admin/api/payouts/${id}/changes`,
    entity: JSON.stringify(payload),
  });
};

const updateInvoice = async (id, payload) => {
  return client({
    method: 'POST',
    path: `/admin/api/invoices/${id}/changes`,
    entity: JSON.stringify(payload),
  });
};

const Utils = {
  getCarrierPayouts: (id, params) => {
    return getCarrierPayouts(id, params);
  },
  getPayouts: (params) => {
    return getPayouts(params);
  },
  getPayoutsByNumbers: (payoutNumbers, page, pageSize) => {
    return getPayoutsByNumbers(payoutNumbers, page, pageSize);
  },
  getPayoutsForShipment: (shipmentId) => {
    return getPayoutsForShipment(shipmentId);
  },
  setAutopayEnabled: (id, enabled) => {
    setAutopayEnabled(id, enabled).then(
      function success(response) {
        var payout = response.entity.data;
        AdminServerActionCreators.receivePayouts([payout]);
      },
      function fail(e) {
        console.error('failed to mark payout as autopay enabled', e);
      },
    );
  },
  getCarrierPayout: (userId, id) => {
    getCarrierPayout(userId, id).then(
      function success(response) {
        var payout = response.entity.payout;
        AdminServerActionCreators.receivePayout(payout);
      },
      function fail(e) {
        console.error('failed to get payouts', e);
      },
    );
  },
  reprocessCarrierPayout: (id) => {
    return new Promise((resolve, reject) => {
      reprocessCarrierPayout(id).then(
        (r) => {
          trackPayoutEvent(
            EVENTS.PAYOUT_REFRESHED,
            r?.entity?.payout ?? { _id: id },
          );
          return resolve(r.entity);
        },
        (r) => {
          return reject(r.entity);
        },
      );
    });
  },
  settlePayout: (id) => {
    return new Promise((resolve, reject) => {
      settlePayout(id).then(
        (response) => {
          const payout = response.entity.payout;
          return resolve(payout);
        },
        (response) => {
          const error = response.entity.error;
          showToast('Failed to settle payout', `${error}`, 'error');
          return reject(new Error(error));
        },
      );
    });
  },
  getPayout: (id) => {
    getPayout(id).then(
      function success(response) {
        var payout = response.entity.payout;
        AdminServerActionCreators.receivePayout(payout);
      },
      function fail(e) {
        console.error('failed to get payouts', e);
      },
    );
  },
  addPayouts: (params) => {
    getPayouts(params).then(
      function success(response) {
        var list = response.entity.data;
        AdminServerActionCreators.addPayouts(list);
      },
      function fail(e) {
        console.error('failed to get payouts', e);
      },
    );
  },
  getAdminInvoices: (params) => {
    return getAdminInvoices(params);
  },
  getInvoicesByNumber: (params) => {
    return getInvoicesByNumber(params);
  },
  getInvoicesByNumberShipper: (shipperId, params) => {
    return getInvoicesByNumberShipper(shipperId, params);
  },
  getShipperInvoices: (shipperId, params) => {
    return getShipperInvoices(shipperId, params);
  },
  getAdminInvoicesStats: (params) => {
    return getAdminInvoicesStats(params);
  },
  getShipperInvoicesStats: (shipperId, params) => {
    return getShipperInvoicesStats(shipperId, params);
  },

  getInvoicesForShipment: (shipmentId) => {
    return getInvoicesForShipment(shipmentId);
  },
  getInvoice: (id, userType) => {
    getInvoice(id, userType).then(
      function success(response) {
        var invoice = response.entity.invoice;
        AdminServerActionCreators.receiveInvoices([invoice]);
      },
      function fail(e) {
        console.error('failed to get payouts', e);
      },
    );
  },
  setInvoicePaymentMethod: (method, invoiceId) => {
    setInvoicePaymentMethod(method, invoiceId).then(
      function success(response) {
        const invoice = response.entity.invoice;
        AdminServerActionCreators.receiveInvoice(invoice);
      },
      function fail(e) {
        console.log('failed to update invoice', e);
      },
    );
  },
  setPayoutPaymentMethod: (payment_method, payoutId) => {
    setPayoutPaymentMethod(payment_method, payoutId).then(
      function success(response) {
        const payout = response.entity.payout;
        AdminServerActionCreators.receivePayout(payout);
      },
      function fail(e) {
        console.log('failed to update invoice', e);
      },
    );
  },
  markPayoutAsPaid: (id) => {
    markPayoutAsPaid(id).then(
      function success(response) {
        var payout = response.entity.payout;
        AdminServerActionCreators.receivePayouts([payout]);
      },
      function fail(e) {
        console.error('failed to mark payout as paid', e);
      },
    );
  },
  markInvoiceAsPaid: (id) => {
    markInvoiceAsPaid(id).then(
      function success(response) {
        var invoice = response.entity.invoice;
        AdminServerActionCreators.receiveInvoices([invoice]);
      },
      function fail(e) {
        console.error('failed to mark invoice as paid', e);
      },
    );
  },
  approvePayout: (id) => {
    approvePayout(id).then(
      function success(response) {
        var payout = response.entity.data;
        AdminServerActionCreators.receivePayout(payout);
      },
      function fail(e) {
        console.error('failed to mark invoice as paid', e);
      },
    );
  },
  reversePayoutApproval: (id) => {
    reversePayoutApproval(id).then(
      function success(response) {
        var payout = response.entity.data;
        AdminServerActionCreators.receivePayout(payout);
      },
      function fail(e) {
        console.error('failed to mark invoice as paid', e);
      },
    );
  },
  voidPayout: (id) => {
    voidPayout(id).then(
      function success(response) {
        var payout = response.entity.data;
        AdminServerActionCreators.receivePayout(payout);
      },
      function fail(e) {
        console.error('failed to mark invoice as void', e);
      },
    );
  },
  reversePayoutVoid: (id) => {
    reversePayoutVoid(id).then(
      function success(response) {
        var payout = response.entity.data;
        AdminServerActionCreators.receivePayout(payout);
      },
      function fail(e) {
        console.error('failed to reverse payout void', e);
      },
    );
  },
  recordPaymentForPayout: (id, paymentInfo) => {
    recordPaymentForPayout(id, paymentInfo).then(
      function success(response) {
        const payout = response.entity.data;
        AdminServerActionCreators.receivePayout(payout);
      },
      function fail(e) {
        console.error('Failed to save payment for payout', e);
      },
    );
  },
  recordPaymentForInvoice: (id, paymentInfo) => {
    recordPaymentForInvoice(id, paymentInfo).then(
      function success(response) {
        const invoice = response.entity.data;
        AdminServerActionCreators.receiveInvoice(invoice);
      },
      function fail(e) {
        console.error('Failed to save payment for invoice', e);
      },
    );
  },

  emailPayout: (id, to) => {
    const sentTo = _.isArray(to) ? to.join('\n') : to;
    emailPayout(id, to).then(
      function success(response) {
        AdminServerActionCreators.emailSent(sentTo);
      },
      function fail(e) {
        AdminServerActionCreators.emailFailed(sentTo);
      },
    );
  },

  emailInvoice: (id, to, isCreditMemo) => {
    const sentTo = _.isArray(to) ? to.join('\n') : to;
    emailInvoice(id, to, isCreditMemo).then(
      function success(response) {
        AdminServerActionCreators.emailSent(sentTo);
      },
      function fail(e) {
        AdminServerActionCreators.emailFailed(sentTo);
      },
    );
  },

  createCharge: (invoice, amount, password) => {
    var path = '/admin/api/v2/invoices/' + invoice._id + '/charges',
      entity = JSON.stringify({
        amount_in_cents: amount,
        password: password,
      });

    return client({
      method: 'POST',
      path: path,
      entity: entity,
    })
      .then((res) => {
        AdminServerActionCreators.createdCharge(res.entity.data);
        console.log(res);
        return res;
      })
      .catch((res) => {
        AdminServerActionCreators.failedCharge(res);
      });
  },

  createPayment: (payout, amount, password) => {
    var path = '/admin/api/v2/payouts/' + payout._id + '/transfers',
      entity = JSON.stringify({
        amount_in_cents: amount,
        password: password,
      });

    return client({
      method: 'POST',
      path: path,
      entity: entity,
    })
      .then((res) => {
        AdminServerActionCreators.createdPayout(res.entity.data);
        console.log(res);
        return res;
      })
      .catch((res) => {
        AdminServerActionCreators.failedPayout(res);
      });
  },

  fundStripe: (amount, password) => {
    var path = '/api/v2/loot',
      entity = JSON.stringify({
        amount_in_cents: amount,
        password: password,
      });

    return client({
      method: 'POST',
      path: path,
      entity: entity,
    })
      .then((res) => {
        AdminServerActionCreators.stripeFunded(res.entity.data);
        console.log(res);
        return res;
      })
      .catch((res) => {
        AdminServerActionCreators.stripeFundingFailed(res);
      });
  },

  regenerateInvoice(invoiceId, type, data) {
    if (type === 'drayage') {
      regenerateOrderInvoice(invoiceId, data)
        .then(() => {
          trackInvoiceEvent(EVENTS.INVOICE_REGENERATED, { _id: invoiceId }, { type });
          showToast(
            i18next.t('REGENERATE_INVOICE'),
            i18next.t('INVOICE_REGENERATE_SUCCESS'),
            'success',
          );
        })
        .catch((err) =>
          showToast(
            i18next.t('REGENERATE_INVOICE'),
            i18next.t('INVOICE_REGENERATE_ERROR'),
            'error',
          ),
        );
    } else {
      regenerateShorthaulInvoice(invoiceId)
        .then((response) => {
          trackInvoiceEvent(
            EVENTS.INVOICE_REGENERATED,
            response?.entity?.invoice ?? { _id: invoiceId },
            { type },
          );
          AdminServerActionCreators.regenerateInvoiceSuccess(response);
        })
        .catch((err) => AdminServerActionCreators.regenerateInvoiceFail(err));
    }
  },

  approveAccessorials(body) {
    approveAccessorials(body).then(
      (response) => {
        const successes = response.entity?.result?.successes ?? [];
        trackAccessorialEvent(
          EVENTS.ACCESSORIAL_APPROVED,
          successes.flatMap((s) =>
            (s.accessorials ?? []).map((a) => ({ ...a, shipment: s.job })),
          ),
        );
        AdminServerActionCreators.approveAccessorialsSuccess(response.entity);
      },
      (e) => AdminServerActionCreators.approveAccessorialsFail(e),
    );
  },

  async sendEdiInvoice(invoiceId) {
    return sendEdiInvoice(invoiceId).then(
      (response) => {
        showToast('Send EDI', i18next.t('EDI_INVOICE_SENT'));
        return response;
      },
      (error) => {
        const message =
          error && error.message
            ? i18next.t('INVOICE_EDI_FAIL_REASON', { reason: error.message })
            : i18next.t('INVOICE_EDI_FAIL');
        showToast('Send EDI', message, 'error');
        throw error;
      },
    );
  },

  async updatePayoutJobs(payout, jobIds, action) {
    return updatePayoutJobs(payout, jobIds, action).then(
      (res) => {
        return res.entity.data;
      },
      (error) => {
        throw error;
      },
    );
  },

  async updateInvoiceJobs(invoice, jobIds, action) {
    return updateInvoiceJobs(invoice, jobIds, action).then(
      (res) => {
        return res.entity.data;
      },
      (error) => {
        const message =
          error && error.entity && error.entity.error
            ? `Invoice update failed due to: ${error.entity.error}`
            : 'Invoice update failed';
        showToast('Add/Remove Shipment', message, 'error');
        throw error;
      },
    );
  },

  async updateInvoiceLineItems(id, version, changes) {
    const payload = {
      version,
      changes,
    };
    return updateInvoice(id, payload)
      .then((res) => {
        AdminServerActionCreators.updateInvoiceSuccess(res);
        return res.entity.data;
      })
      .catch((err) => AdminServerActionCreators.updateInvoiceFail(err));
  },

  async updatePayoutLineItems(id, version, changes) {
    const payload = {
      version,
      changes,
    };
    return updatePayout(id, payload).then(
      (response) => {
        showToast('Update Payout', 'Payout Items Updated Succesfully');
        return response.entity.data;
      },
      (error) => {
        showToast('Update Payout', error, 'error');
      },
    );
  },

  removeLineItem: async (lineItem, accounting_type, shipment_id) => {
    const queryString = qs.stringify({
      shipment_id,
      accounting_type,
    });

    const options = {
      method: 'delete',
      url: `${API_HOST}/admin/v2/accessorials/${lineItem}?${queryString}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: getBearerGrantTypeAuthHeaders(),
      },
    };
    return axios(options);
  },
};

AdminAppDispatcher.register((payload) => {
  var data = payload.action;
  switch (data.type) {
    case Actions.INVOICE_CHARGE_CREATE:
      Utils.createCharge(data.invoice, data.amount, data.password);
      break;
    case Actions.PAYOUT_PAYMENT_CREATE:
      Utils.createPayment(data.payout, data.amount, data.password);
      break;
    case Actions.FUND_STRIPE:
      Utils.fundStripe(data.amount, data.password);
      break;
    default:
  }
});

export default Utils;
